import PropTypes from 'prop-types';

import { legacyTheme, styled } from '@prose-ui/legacy';

import { scoringGoals } from 'assets/content/prescription/content';

import ScoringList from './ScoringList';

const HairProfileWrapper = styled('div')`
  ${legacyTheme.breakpoints.up('md')} {
    width: 95%;
  }

  ${legacyTheme.breakpoints.up('lg')} {
    width: 550px;
    margin: 0 auto;
  }
`;

const HairProfile = ({ scoring, scoringContent, onScoringSelectChange }) => {
  const goals = scoringContent
    .getGoalValue(scoring)
    .sort((firstItem, secondItem) => secondItem.value - firstItem.value);

  return (
    <HairProfileWrapper>
      <ScoringList goals={goals} onScoringSelectChange={onScoringSelectChange} />
    </HairProfileWrapper>
  );
};

HairProfile.propTypes = {
  scoringContent: PropTypes.shape({ getGoalValue: PropTypes.func }),
  scoring: PropTypes.shape({}).isRequired,
  onScoringSelectChange: PropTypes.func.isRequired,
};

HairProfile.defaultProps = {
  scoringContent: scoringGoals,
};

export default HairProfile;
